const SCROLL_ANIMATION_TRIGGER_CLASSNAME = 'scroll-trigger';
const SCROLL_ANIMATION_OFFSCREEN_CLASSNAME = 'scroll-trigger--offscreen';
const SCROLL_ZOOM_IN_TRIGGER_CLASSNAME = 'animate--zoom-in';
const SCROLL_ANIMATION_CANCEL_CLASSNAME = 'scroll-trigger--cancel';

// Scroll in animation logic
function onIntersection(elements, observer) {
  elements.forEach((element, index) => {
    if (element.isIntersecting) {
      const elementTarget = element.target;
      if (elementTarget.classList.contains(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME)) {
        elementTarget.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
        if (elementTarget.hasAttribute('data-cascade'))
          elementTarget.setAttribute('style', `--animation-order: ${index};`);
      }
      observer.unobserve(elementTarget);
    } else {
      element.target.classList.add(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
      element.target.classList.remove(SCROLL_ANIMATION_CANCEL_CLASSNAME);
    }
  });
}

function initializeScrollAnimationTrigger(rootEl = document, isDesignModeEvent = false) {
  const animationTriggerElements = Array.from(rootEl.getElementsByClassName(SCROLL_ANIMATION_TRIGGER_CLASSNAME));
  if (animationTriggerElements.length === 0) return;

  if (isDesignModeEvent) {
    animationTriggerElements.forEach((element) => {
      element.classList.add('scroll-trigger--design-mode');
    });
    return;
  }

  const observer = new IntersectionObserver(onIntersection, {
    rootMargin: '0px 0px -50px 0px',
  });
  animationTriggerElements.forEach((element) => observer.observe(element));
}

// Zoom in animation logic
function initializeScrollZoomAnimationTrigger() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const animationTriggerElements = Array.from(document.getElementsByClassName(SCROLL_ZOOM_IN_TRIGGER_CLASSNAME));

  if (animationTriggerElements.length === 0) return;

  const scaleAmount = 0.2 / 100;

  animationTriggerElements.forEach((element) => {
    let elementIsVisible = false;
    const observer = new IntersectionObserver((elements) => {
      elements.forEach((entry) => {
        elementIsVisible = entry.isIntersecting;
      });
    });
    observer.observe(element);

    element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));

    window.addEventListener(
      'scroll',
      throttle(() => {
        if (!elementIsVisible) return;

        element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));
      }),
      { passive: true }
    );
  });
}

function percentageSeen(element) {
  const viewportHeight = window.innerHeight;
  const scrollY = window.scrollY;
  const elementPositionY = element.getBoundingClientRect().top + scrollY;
  const elementHeight = element.offsetHeight;

  if (elementPositionY > scrollY + viewportHeight) {
    // If we haven't reached the image yet
    return 0;
  } else if (elementPositionY + elementHeight < scrollY) {
    // If we've completely scrolled past the image
    return 100;
  }

  // When the image is in the viewport
  const distance = scrollY + viewportHeight - elementPositionY;
  let percentage = distance / ((viewportHeight + elementHeight) / 100);
  return Math.round(percentage);
}

window.addEventListener('DOMContentLoaded', () => {
  initializeScrollAnimationTrigger();
  initializeScrollZoomAnimationTrigger();
});

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => initializeScrollAnimationTrigger(event.target, true));
  document.addEventListener('shopify:section:reorder', () => initializeScrollAnimationTrigger(document, true));
}
// ======================================
// UNIVERSAL F1 ADD TO CART ANIMATION
// ======================================
const f1Sound = new Audio("https://cdn.shopify.com/s/files/1/0799/8003/6333/files/f1_v10_sound.mp3?v=1772342286");
function runF1Animation(sourceElement) {

  const img =
    sourceElement.closest('.card')?.querySelector('img') ||
    sourceElement.closest('.product')?.querySelector('img');

  if (!img) return;

  const cartIcon = document.querySelector('#cart-icon-bubble');
  if (!cartIcon) return;

  const imgRect = img.getBoundingClientRect();
  const cartRect = cartIcon.getBoundingClientRect();

  const car = document.createElement("div");
  car.innerHTML = "🏎️";
  car.style.position = "fixed";
  car.style.left = imgRect.left + imgRect.width / 2 + "px";
  car.style.top = imgRect.top + imgRect.height / 2 + "px";
  car.style.fontSize = "28px";
  car.style.zIndex = "9999";
  car.style.transition = "all 0.9s cubic-bezier(.65,-0.25,.25,1.15)";
  car.style.pointerEvents = "none";

  document.body.appendChild(car);

  const trail = document.createElement("div");
  trail.style.position = "fixed";
  trail.style.left = car.style.left;
  trail.style.top = car.style.top;
  trail.style.width = "40px";
  trail.style.height = "6px";
  trail.style.background = "linear-gradient(to right, #ff3c00, transparent)";
  trail.style.borderRadius = "4px";
  trail.style.zIndex = "9998";
  trail.style.transition = "all 0.9s ease";
  trail.style.opacity = "0.8";

  document.body.appendChild(trail);

try {
  const isMobile = window.matchMedia("(max-width: 768px)").matches;

  // Very low mobile volume
  f1Sound.volume = isMobile ? 0.001 : 0.8;

  f1Sound.currentTime = 0;
  f1Sound.play();

} catch (err) {}
  setTimeout(() => {
    car.style.left = cartRect.left + "px";
    car.style.top = cartRect.top + "px";
    car.style.transform = "scale(0.5)";
    car.style.opacity = "0.3";

    trail.style.left = cartRect.left - 30 + "px";
    trail.style.top = cartRect.top + "px";
    trail.style.opacity = "0";
  }, 50);

  setTimeout(() => {
    car.remove();
    trail.remove();

    cartIcon.classList.add('cart-shake');
    setTimeout(() => {
      cartIcon.classList.remove('cart-shake');
    }, 600);

  }, 900);
}

// Listen for ANY add-to-cart form submission
document.addEventListener("submit", function (e) {

  if (e.target.matches('form[action*="/cart/add"]')) {
    runF1Animation(e.target);
  }

});
// ===== COLLECTION PAGE (Trade quick-add-bulk) =====
document.addEventListener("click", function (e) {

  const plusButton = e.target.closest('button.quantity__button[name="plus"]');
  if (!plusButton) return;

  const insideBulk = plusButton.closest('quick-add-bulk');
  if (!insideBulk) return;

  runF1Animation(plusButton);

});